module.exports = __webpack_public_path__ + "media/images/business/slide-arrow-prev-000d5ec086291316ae3643a0cf7f4b48.svg";